import React from "react";
import PropTypes from "prop-types";
import Container from "public-components/Container";
import styles from "./CtaSection.module.scss";
import { Store } from "public-components/StoreProvider";
import Sign from "public-components/Sign";

const CtaSection = ({ data }) => {
  const { state, dispatch } = React.useContext(Store);
  const { userInfo, showAuthModal, signType } = state;
  React.useEffect(() => {
    !userInfo && dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: false });
  }, [userInfo, dispatch]);
  const signUp = () => {
    if (!userInfo) {
      dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: true });
      dispatch({ type: "SIGNTYPE", signType: "signUp" });
    }
  };
  const callback = () => {
    dispatch({ type: "SHOW_AUTH_MODAL", showAuthModal: false });
    dispatch({ type: "SIGNTYPE", signType: "login" });
  };
  return (
    <section className={styles.cta}>
      <Container>
        <div className={styles.cta__content}>
          <h2 className={styles.cta__heading}>{data.headingH2}</h2>
          {!userInfo && (
            <button className={styles.cta__signupButton} onClick={signUp}>
              {data.homeCtaButtonText}
            </button>
          )}
          {showAuthModal && <Sign authModal="loginCOM" signType={signType} callback={callback} />}
        </div>
      </Container>
    </section>
  );
};

CtaSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homeCtaButtonText: PropTypes.string.isRequired
  }).isRequired
};

export default CtaSection;
